export default "__VITE_ASSET__WdJxwajR__"